module.exports = new __parcel__URL__("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg").toString();